import { createRef, ChangeEvent } from "react";

import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { ICreateModalidade } from "src/Contexts/comissoes/ComissoesTypes";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";


export const FormModalidade = () => {
  const { valuesInputsModalidade, setValuesInputsModalidade } =
    useContextComissoes();

  const refOrigem = createRef<HTMLInputElement>();

  const handleChange =
    (prop: keyof ICreateModalidade) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      setValuesInputsModalidade({
        ...valuesInputsModalidade,
        [prop]: event.target.value,
      });
    };

  return (
    <AppTextField
      fullWidth
      inputRef={refOrigem}
      label="Modalidade *"
      sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
      value={valuesInputsModalidade?.name}
      variant="outlined"
      onChange={handleChange("name")}
    />
  );
};
